import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import { Form } from "@rocketseat/unform";

import {
	isMobile,
	getSessionStorageKey,
	setSessionStorageKey,
	changePath,
	removeStorageKey,
	detectAutofill,
	isDataInStorageKey,
} from "../../utils";
import history from "../../services/history";
import CircularProgress from "@material-ui/core/CircularProgress";

import {
	authenticatePrepareLogin,
	respRequestError,
	socialLogin,
	socialMediaAuthenticateRequest,
} from "../../store/modules/auth/actions";

import {
	Container,
	Content,
	Title,
	FormGroupInput,
	FormGroupLine,
	SubmitButtom,
	ButtonOpenAccount,
	InputCpf,
	InputText,
	Label,
	BoxLogin,
	MessageError,
	PasswordEye,
	LoginSocial,
	ContainerBlur,
	Blur,
	ContainerButton,
} from "./styles";

import { selectedPlanByIdRequest, setParamRoute } from "../../store/modules/billingPlan/actions";
import { initialStateCheck } from "../../store/modules/sessionStorage/actions";
import Tooltip from "react-bootstrap/Tooltip";
import Overlay from "react-bootstrap/Overlay";
import { GoogleLogin } from "react-google-login";
// eslint-disable-next-line
import FacebookLogin from "react-facebook-login";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import NewLogoSVG from "../../components/NewLogo";
import { toast } from "react-toastify";
import { GOOGLE_CLIENT_LOGIN } from "../../keys";
import FluxPromotional from "../../components/FluxPromotional";
import { useAdjust } from "../../hook/useAdjust";
import FormLoginCheckout from "../../components/FormLoginCheckout";

export default function Login(props) {
	const dispatch = useDispatch();

	const target = useRef();

	const { adid } = useAdjust();

	const { loading, respError, removeCache, newUsername, loadingSocialLogin, showModal, loginFail } =
		useSelector((state) => state.auth);

	const { toMarket } = useSelector((state) => state.register);
	const { isFluxPromotional } = useSelector((state) => state.billingPlan);
	const { id_league, cod_campaign, id_plan, cd_plan, id_research, reactive_path, campaign, redirect_path } =
		useParams();
	const isExpiredSession = false;
	const [cpf, setCpf] = useState("");
	const [password, setPassword] = useState("");
	const [isProAuth, setIsProAuth] = useState(false);
	const [errors, setErrors] = useState({
		cpf: {
			value: true,
			read: false,
		},
		password: {
			value: true,
			read: false,
		},
	});
	const [change, setChange] = useState(false);
	// const [loadingFacebook, setLoadingFacebook] = useState(false)
	const [loadingGoogle, setLoadingGoogle] = useState(false);
	const [disableInput, setDisableInput] = useState(false);
	const [show, setShow] = useState(false);
	const [hidePassword, setHidePassword] = useState(true);

	const [paramsQuery] = useState(new URLSearchParams(useLocation().search));

	useEffect(() => {
		let count = 0;

		const interval = setInterval(() => {
			const isDetected = detectAutofill(document.querySelector("#cpf"));
			count += 1;

			if (isDetected) {
				setErrors({
					cpf: {
						value: false,
						read: true,
					},
					password: {
						value: false,
						read: true,
					},
				});
				clearInterval(interval);
			}

			if (count >= 10) {
				clearInterval(interval);
			}
		}, 1000);

		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		const infoUserLogin = JSON.parse(localStorage.getItem("INFO_USER_LOGIN"));
		if (infoUserLogin && change && newUsername) {
			setCpf(infoUserLogin.email);
		}
	}, [newUsername]);

	useEffect(() => {
		if (localStorage.getItem("remember")) {
			localStorage.removeItem("remember");
		}

		if (!paramsQuery.get("flux-promotional")) {
			const keyListInStorage = ["COMBO_PROMOTIONAL_FLOW", "PROMOTIONAL_FLOW", "FLUX_PROMO"];

			for (let value of keyListInStorage) {
				removeStorageKey(value);
			}
		}

		const listOfKeysInStorageToRemove = ["TRADE_CHAT_AUTH", "TRIGGER_EVENT_AT_CHECKOUT"];

		for (let value of listOfKeysInStorageToRemove) {
			if (isDataInStorageKey(value)) {
				removeStorageKey(value);
			}
		}
	}, []);

	useEffect(() => {
		if (sessionStorage.getItem("IS_ABANDONADED")) sessionStorage.removeItem("IS_ABANDONADED");

		if (removeCache) {
			if (localStorage.getItem("cd_access_token")) {
				setTimeout(() => {
					localStorage.removeItem("cd_access_token");
				}, 1000);
			}

			const removeItems = [
				"flow-checkout",
				"flow-checkout-plan",
				"FLUX_INFLUENCER",
				"flow-checkout-id",
				"CACHEDPLAN",
			];

			for (let value of removeItems) {
				removeStorageKey(value);
			}
		}
	}, []);

	useEffect(() => {
		if (showModal) {
			setDisableInput(false);
			setShow(true);
			setCpf("");
			setPassword("");
		}
	}, [showModal]);

	useEffect(() => {
		if (show) {
			const message = () => (
				<div>
					<span>
						E-mail não encontrado na base. <b>Abra sua conta</b> ou{" "}
						<b>entre</b> para vincular sua rede social.
					</span>
				</div>
			);
			toast.info(message, { autoClose: false });
		}
	}, [show]);

	useEffect(() => {
		const pathProAuth = "/onboard/updadrade-pro-authentication";
		const { match } = props;
		const { path } = match;
		const isProAuth = pathProAuth === path;
		setIsProAuth(isProAuth);
	}, [props]);

	useEffect(() => {
		function setParamsRoute() {
			dispatch(
				setParamRoute({
					id_plan,
					id_league,
					cod_campaign,
					cd_plan,
					id_research,
					campaign,
					redirect_path,
				})
			);
		}
		setParamsRoute();
		// eslint-disable-next-line
	}, [id_plan, id_league, cod_campaign, cd_plan, id_research, campaign, redirect_path]);

	useEffect(() => {
		function selectedPlanById() {
			if (id_plan) {
				dispatch(selectedPlanByIdRequest(id_plan));
			}
		}
		selectedPlanById();
		// eslint-disable-next-line
	}, [id_plan]);

	useEffect(() => {
		dispatch(initialStateCheck("login"));
		const plan = getSessionStorageKey("PLANSELECTED");
		if (
			!localStorage.getItem("CACHEDPLAN") &&
			(!localStorage.getItem("flow-checkout") || !localStorage.getItem("flow-checkout-plan"))
		) {
			sessionStorage.clear();
		}

		if (plan) setSessionStorageKey("PLANSELECTED", plan);

		function rememberMe() {
			localStorage.setItem("appflow", "");
		}

		rememberMe();

		const storageData = ["INFO_USER_LOGIN", "AUTHENTICATED"];

		for (let element of storageData) {
			if (isDataInStorageKey(element)) {
				localStorage.removeItem(element);
				setShow(false);
			}
		}
	}, []);

	useEffect(() => {
		window.addEventListener("popstate", stayInPromotionalFlow);
		window.addEventListener("load", stayInPromotionalFlow);

		return () => {
			window.removeEventListener("load", stayInPromotionalFlow);
			window.removeEventListener("popstate", stayInPromotionalFlow);
		};
		// eslint-disable-next-line
	}, [paramsQuery]);

	const stayInPromotionalFlow = (event) => {
		event.preventDefault();

		const fluxPromo = JSON.parse(localStorage.getItem("FLUX_PROMO"));

		if (
			fluxPromo &&
			fluxPromo.isPromo &&
			paramsQuery.get("flux-promotional") &&
			["back_forward", "reload"].includes(
				window.performance
					.getEntriesByType("navigation")
					.map((nav) => nav.type)
					.at(0)
			)
		) {
			changePath(fluxPromo.route);
		}
	};

	function autenticate(cpf, password) {
		if (Boolean(reactive_path) && reactive_path === "plano") {
			localStorage.setItem("flow-reactive-plan", true);
		}

		const uriParams = new URLSearchParams(window.location.search);
		const sso = uriParams.get("sso");
		const sig = uriParams.get("sig");
		const entries = Object.fromEntries(uriParams) || [];
		const options = Boolean(entries.length);

		if (sso !== null && sig !== null) {
			dispatch(socialMediaAuthenticateRequest(unformatCpf(cpf), password, sso, sig));
		} else {
			dispatch(
				authenticatePrepareLogin(
					unformatCpf(cpf),
					password,
					isProAuth,
					options,
					toMarket,
					adid
				)
			);
			history.push("/onboard/prepare-login");
		}
	}

	function ExpiredSession() {
		return <div className="alert alert-danger">Sua sessão expirou, clique em login novamente.</div>;
	}

	function unformatCpf(cpf) {
		if (!cpf.includes("@")) {
			return cpf.trim().replace(/\.|-|[()]|[+]|[ ]/g, "");
		}
		return cpf.trim().toLowerCase();
	}

	function goToWelcome(appflow) {
		var path = "/onboard/welcome";
		if (appflow === "RECOVER") {
			path = "/onboard/recover-account";
		}
		localStorage.setItem("appflow", appflow);
		history.push(path);
	}

	function keyPressed(event, field) {
		if (event.key === "Enter") {
			// autenticate(cpf, password, mustRemember);
		}
		if (event.key === "Tab" && field === "cpf") {
			event.preventDefault();
			document.getElementById("password").focus();
		}
	}

	function handleChange(event) {
		dispatch(respRequestError(false));
		event.preventDefault();
		const { name, value } = event.target;
		let actions = {
			cpf: () => {
				errors.cpf.value = !value.length ? true : false;
				errors.cpf.read = true;
				localStorage.setItem("SET_ZERO", true);

				setCpf(value);
			},
			password: () => {
				errors.password.value = !value.length ? true : false;
				errors.password.read = true;
				setPassword(value);
			},
		};

		if (Object.keys(actions).includes(name) !== -1) {
			actions[name]();
		}

		setErrors(errors);
	}

	const responseGoogle = (response) => {
		if (localStorage.getItem("AUTHENTICATED") || localStorage.getItem("INFO_USER_LOGIN")) {
			localStorage.removeItem("AUTHENTICATED");
			localStorage.removeItem("INFO_USER_LOGIN");
		}

		let { googleId, profileObj } = response;
		if (profileObj) {
			let { name, email } = profileObj;

			let data = {
				name: name,
				email: email,
				id: googleId,
				idSocial: 2,
			};

			localStorage.setItem("INFO_USER_LOGIN", JSON.stringify(data));
		}
		dispatch(socialLogin(response.accessToken, 2, toMarket));
		setLoadingGoogle(true);
		// setLoadingFacebook(false)
		setChange(true);
		setErrors({
			cpf: {
				value: false,
				read: true,
			},
			password: {
				value: false,
				read: true,
			},
		});
		setDisableInput(true);
	};

	const errorGoogle = (resp) => {
		console.error("Google", resp);
	};

	// const errorFacebook = (resp) => {
	//   console.error('Facebook', resp)
	// }

	// const responseFacebook = (response) => {
	//   if (localStorage.getItem('AUTHENTICATED') || localStorage.getItem('INFO_USER_LOGIN')) {
	//     localStorage.removeItem('AUTHENTICATED')
	//     localStorage.removeItem('INFO_USER_LOGIN')
	//   }

	//   let { name, email, userID } = response;

	//   let data = {
	//     name: name,
	//     email: email,
	//     id: userID,
	//     idSocial: 1
	//   };

	//   localStorage.setItem('INFO_USER_LOGIN', JSON.stringify(data));
	//   dispatch(socialLogin(response.accessToken, 1, toMarket));
	//   setLoadingFacebook(true)
	//   setLoadingGoogle(false)
	//   setChange(true)
	//   setErrors({
	//     cpf: {
	//       value: false,
	//       read: true,
	//     },
	//     password: {
	//       value: false,
	//       read: true,
	//     },
	//   });
	//   setDisableInput(true);
	// }

	return (
		<Container id="login">
			{isFluxPromotional ? <FluxPromotional /> : <NewLogoSVG />}
			{isFluxPromotional ? (
				<FormLoginCheckout />
			) : (
				<Content>
					{isExpiredSession ? ExpiredSession : null}
					<Form onSubmit={() => autenticate(cpf, password)}>
						<Title>Entre ou crie sua conta</Title>
						<FormGroupInput>
							<Label>E-mail, CPF ou celular</Label>
							<InputCpf
								inputRef={target}
								autoFocus={true}
								name="cpf"
								id="cpf"
								value={cpf}
								onChange={(e) => handleChange(e)}
								onKeyDown={(e) => keyPressed(e, "cpf")}
								error={{ value: loginFail }}
								onFocus={(e) =>
									e.target.removeAttribute(
										"readonly"
									)
								}
								disabled={disableInput}
							/>
							<Overlay
								id="tooltip"
								placement="right"
								target={target.current}
								show={Boolean(respError)}
							>
								{(props) => (
									<Tooltip
										{...props}
										show={props.show.toString()}
									>
										Digite o DDD + o
										número de celular
										<br />
										Ou CPF sem ponto e
										traços
										<br />
										Para e-mail: Ex.
										teste@gmail.com
									</Tooltip>
								)}
							</Overlay>
							{loginFail ? (
								<MessageError>
									E-mail ou senha incorretos,
									revise e tente novamente
								</MessageError>
							) : null}
						</FormGroupInput>
						<FormGroupInput>
							<Label>Senha</Label>
							<div className="container-password">
								<InputText
									id="password"
									name="password"
									type={
										hidePassword
											? "password"
											: "text"
									}
									error={{ value: loginFail }}
									value={password}
									onChange={(e) =>
										handleChange(e)
									}
									onKeyDown={(e) =>
										keyPressed(
											e,
											"password"
										)
									}
								/>
								<PasswordEye
									error={loginFail}
									onClick={() =>
										setHidePassword(
											!hidePassword
										)
									}
								>
									{hidePassword ? (
										<Visibility
											width={18}
										/>
									) : (
										<VisibilityOff
											width={18}
										/>
									)}
								</PasswordEye>
							</div>
							{loginFail ? (
								<MessageError>
									E-mail ou senha incorretos,
									revise e tente novamente
								</MessageError>
							) : null}
						</FormGroupInput>
						<FormGroupLine className="right">
							<button
								type="button"
								onClick={() => goToWelcome("RECOVER")}
							>
								Esqueci a senha
							</button>
						</FormGroupLine>

						<ContainerButton>
							<SubmitButtom
								type="submit"
								disabled={Object.keys(errors).find(
									(key) =>
										Boolean(
											errors[
												key
											].value
										)
								)}
							>
								{loading ? (
									<CircularProgress
										style={{
											width: "20px",
											height: "20px",
											color: "#FFF",
										}}
									/>
								) : (
									"Entrar na minha conta"
								)}
							</SubmitButtom>
							<ButtonOpenAccount
								className="open-account"
								onClick={() => goToWelcome("REGISTER")}
							>
								Criar uma conta
							</ButtonOpenAccount>
						</ContainerButton>

						<LoginSocial> Ou entre com:</LoginSocial>
						<BoxLogin mobile={isMobile.any()}>
							{/* {
              loadingFacebook && !loadingSocialLogin ? (
                <ContainerBlur>
                  <CircularProgress
                    style={{
                      width: '20px',
                      height: '20px',
                      color: '#000',
                      zIndex: 1,
                      position: 'fixed',
                    }}
                  />

                  <Blur>
                    <FacebookLogin
                      cssClass="btn-fb"
                      textButton=''
                      isDisabled={true}
                    />
                  </Blur>
                </ContainerBlur>
              ) : (
                <FacebookLogin
                  appId="375064161122719"
                  autoLoad={false}
                  fields="name,email"
                  cssClass="btn-fb"
                  textButton=''
                  callback={responseFacebook}
                  onFailure={errorFacebook}
                />
              )
            } */}

							{loadingGoogle && !loadingSocialLogin ? (
								<ContainerBlur>
									<CircularProgress
										style={{
											width: "20px",
											height: "20px",
											color: "#000",
											zIndex: 1,
											position: "fixed",
										}}
									/>

									<Blur>
										<GoogleLogin
											buttonText=""
											className="btn-google"
											disabled={
												true
											}
											icon={
												false
											}
										/>
									</Blur>
								</ContainerBlur>
							) : (
								<GoogleLogin
									clientId={GOOGLE_CLIENT_LOGIN}
									buttonText=""
									className="btn-google"
									onSuccess={responseGoogle}
									onFailure={errorGoogle}
									icon={false}
								/>
							)}
						</BoxLogin>
					</Form>
				</Content>
			)}
		</Container>
	);
}
